import { ScoreboardTennisParser } from "./ScoreboardTennisParser";
import { eBranches } from "sb-helpers";
export class ScoreboardParser {
    constructor() { }
    static get instance() {
        if (!ScoreboardParser._instance) {
            ScoreboardParser._instance = new ScoreboardParser();
        }
        return ScoreboardParser._instance;
    }
    parse(sportEvent, sportId, isTeamSwap) {
        switch (Number(sportId)) {
            case eBranches.Tennis: return ScoreboardTennisParser.instance.parse(sportEvent, isTeamSwap);
        }
        return undefined;
    }
}
;
//# sourceMappingURL=ScoreboardParser.js.map